import React from 'react'
import OurProjects from '../CountryComponents/OurProjects'
import HeaderCampaign from '../campagins/HeaderCampaign'
import WhatsImportant from '../CountryComponents/WhatsImportant'
import RelatedProjects from '../CountryComponents/RelatedProjects'
import AlbumCard from '../CountryComponents/AlbumCard'
import { LazyLoadImage } from 'react-lazy-load-image-component'



function Country() {


    return (
        <>
            <div className="relative h-[462px]">
                <div className="w-full h-[462px] overflow-hidden">
                    <LazyLoadImage className="object-cover w-full h-full" src="https://s3-alpha-sig.figma.com/LazyLoadImage/88cb/87f0/a892bec6f1cc314545165401c998d03f?Expires=1709510400&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=myV3T-fwaB27JLKAGcw0bG36a-RQBycwNOQrPqkjVextFBi-wds9zktm6FaP27VHVljwtU0Oe-0OfLw1JBT-xbjGl75sZcL6O-ojVDrh-R7CYQVsM4SFc58yBzyyyJeiMtVEP8Yy4dS0Rs~jiEutiU8-POvSMwk1xDl7CkMHO9oOe~aT2U7-DHTCoxiW3kLc2R9dGS-i8isfdS8RySzGOlUCC8veLiSNXIv2AIsEZP66ZX4OCkCkiTkRUtAQVrRB3-3oIRAOW1lDRuf1gnRSnMZ~fUPkZyOALjZ7QBJPZkAIesFpsbZRO0zaXSsoXPf7xQ32G7pAs2SudaDMsZTOSQ__" alt="Image" />
                </div>
            </div>
            <div className="relative bottom-48 flex flex-col mx-auto max-w-7xl gap-6  w-full rounded-lg p-4">
                <div className="justify-center px-5 pt-1 text-5xl font-bold text-right text-black whitespace-nowrap bg-white bg-opacity-80 rounded-[100px] w-fit leading-[63px]">
                    فلسطين
                </div>
                <div className="flex flex-col p-8 bg-white rounded-2xl max-md:px-5">
                    <div className="text-3xl font-bold text-right text-zinc-900 max-md:max-w-full">
                        الإحتياجات الإنسانية
                    </div>
                    <div className="mt-8 text-lg font-medium leading-7 text-right text-zinc-900 max-md:max-w-full">
                        في فلسطين، تواجه السكان تحديات إنسانية كبيرة نتيجة الظروف السياسية
                        والاقتصادية الصعبة. يشمل ذلك صعوبة الوصول إلى الرعاية الصحية الأساسية
                        والتعليم، وارتفاع معدلات البطالة وصعوبة الحصول على السكن اللائق. إضافة
                        إلى ذلك، تأثرت البنية التحتية والمأوى بشكل كبير جراء النزاعات الدائرة.{" "}
                    </div>
                    <div className="mt-8 max-md:max-w-full">
                        <div className="flex gap-5 max-md:flex-col max-md:gap-0 max-md:">
                            <div className="flex flex-col ml-5 w-[65%] max-md:ml-0 max-md:w-full">
                                <div className="flex flex-col grow self-stretch text-lg font-medium leading-7 text-right text-zinc-900 max-md:mt-5 max-md:max-w-full">
                                    <div className="max-md:max-w-full">
                                        تعتبر المساعدات الغذائية والدعم النفسي والاجتماعي أمورًا ضرورية
                                        للكثير من الأسر. من المهم أن يستمر العمل على تلبية هذه
                                        الاحتياجات الإنسانية وتقديم الدعم للسكان في فلسطين لتحسين جودة
                                        حياتهم وتعزيز الاستقرار في المنطقة.
                                    </div>
                                    <div className="mt-5 max-md:max-w-full">
                                        {" "}
                                        يواجه السكان العديد من الاحتياجات الإنسانية بسبب الظروف الصعبة،
                                        بما في ذلك نقص الرعاية الصحية، وصعوبة الوصول إلى الغذاء
                                        والتعليم، وقلة السكن الملائم. النزاعات والصراعات تترك آثارًا
                                        نفسية واجتماعية، مما يجعل الدعم النفسي والاجتماعي ضروريًا. تعمل
                                        المنظمات الإنسانية والدولية على تقديم المساعدة للمجتمعات
                                        المتأثرة لمساعدتهم في تلبية هذه الاحتياجات وتحسين جودة حياته
                                    </div>
                                    <div className="mt-5 max-md:max-w-full">
                                        عاني السكان من نقص في الرعاية الصحية والوصول إلى الغذاء
                                        والتعليم، وتواجه التحديات الاقتصادية والاجتماعية الصعبة.
                                        الصراعات والنزاعات تترك آثارًا نفسية واجتماعية، مما يجعل الدعم
                                        النفسي والاجتماعي ضروريًا. تعمل المنظمات الإنسانية والدولية على
                                        تقديم المساعدة للمجتمعات المتأثرة لمساعدتهم في تلبية هذه
                                        الاحتياجات وتحسين جودة حياته
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-col w-[35%] max-md:ml-0 max-md:w-full">
                                <LazyLoadImage
                                    loading="lazy"
                                    src="https://s3-alpha-sig.figma.com/LazyLoadImage/e3b1/d97a/57cd01226142898f4ee1c193dabd1479?Expires=1709510400&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=XtdmvIaZu6fh0WuBnFpJtMmOZ6iCSpaY6X3IilEE0566Bmr8ACH2xgIFsrBXa2BuC0mE6th6PzS0Ec3LWDXSsUaN4ffpkh3xSijS-tcoaV70SW2Zw6CZJHo1uUgmTv9l9L1dQlcudDPhR4SsRwyviUc66z-KUxAqJ734VlzS0ij1Q0~UIWQ5-lNhrBO6nolGw1F2j7XAJKmKXkffSDLYyUJxWjIBFq1yidfrhIMDn0KT3OLI5t2j76UCef4S-6b61wu5neSP5nrkD-MC4PwYQhFcfz8mJ3THJOLBfVSvJkaQ3A9QRHE5czoX5pQ~UltdTwcgN~kDbiQ3PGrimBfqOQ__"
                                    className="self-stretch my-auto w-full aspect-[1.27] max-md:mt-9 rounded-lg object-cover"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <OurProjects />
                <HeaderCampaign />
                <WhatsImportant />
                <RelatedProjects />
                <AlbumCard />
            </div>
        </>

    )
}

export default Country